import { Button, Col, Row } from 'reactstrap';
import { useEffect, useState } from 'react';
import Select from 'react-select';
import ContentLoader from 'react-content-loader';
import Modal from '../../../components/modal/Modal';
import { getQuarterlyStatements } from '../src/statementApis';
import { useDict } from '../../../contexts/LanguageContext';

const QuarterlyStatementModal = (props) => {
    const dict = useDict();
    const { handleClose, isOpen } = props;

    const [filterOptions, setFilterOptions] = useState([]);
    const [yearFilterValue, selectYearFilterValue] = useState(null);
    const [quarterlyStatementListData, setQuarterlyStatementListData] =
        useState([]);
    const [isFetching, setIsFetching] = useState(false);

    useEffect(() => {
        setIsFetching(true);
        getQuarterlyStatements(handleGetQuarterlyStatements);
        setIsFetching(false);
    }, []);

    const handleGetQuarterlyStatements = (response) => {
        setQuarterlyStatementListData(response);
    };

    useEffect(() => {
        if (quarterlyStatementListData) {
            const options = Object.keys(quarterlyStatementListData)
                .reverse()
                .map((year) => ({
                    label: year,
                    value: year,
                }));
            setFilterOptions(options);

            if (options.length > 0) {
                selectYearFilterValue(options[0]);
            }
        }
    }, [quarterlyStatementListData]);

    const renderContent = () => {
        if (isFetching) {
            return (
                <ContentLoader
                    className="w-100 h-100"
                    gradientDirection="top-bottom"
                >
                    <rect
                        x="0"
                        y="0"
                        rx="20"
                        ry="20"
                        width="100%"
                        height="43"
                    />
                    <rect
                        x="0"
                        y="59"
                        rx="20"
                        ry="20"
                        width="100%"
                        height="43"
                    />
                    <rect
                        x="0"
                        y="118"
                        rx="20"
                        ry="20"
                        width="100%"
                        height="43"
                    />
                </ContentLoader>
            );
        }

        if (yearFilterValue && quarterlyStatementListData) {
            return quarterlyStatementListData[yearFilterValue.value].map(
                (data) => (
                    <Button
                        className="btn-outline-primary rounded w-100"
                        onClick={() => { }}
                    >
                        {data.toDisplay}
                    </Button>
                )
            );
        }

        return (
            <p className="text-center">
                {dict.noStatementsAvailable}
            </p>
        );
    };

    return (
        <Modal
            isOpen={isOpen}
            toggle={handleClose}
            title="Quarterly Statements"
            headerType="review-2"
            onCancel={handleClose}
            cancelText={dict.close}
            testID="quarterStatementModal"
        >
            <div className="modal__body" data-cy="modal__content">
                {yearFilterValue && quarterlyStatementListData ? (
                    <>
                        <Select
                            options={filterOptions}
                            onChange={(e) => selectYearFilterValue(e)}
                            value={yearFilterValue}
                            isLoading={isFetching}
                            placeholder="Select year"
                            styles={{
                                container: (base) => ({
                                    ...base,
                                    display: 'flex',
                                    justifyContent: 'center',
                                    marginTop: 12,
                                }),
                                control: (base) => ({
                                    ...base,
                                    width: '100%',
                                }),
                                menu: (base) => ({
                                    ...base,
                                    width: '100%',
                                }),
                            }}
                        />
                        <p className="font-italic mt-2 mb-2">
                            <small>
                                Select a month to download the statement.
                            </small>
                        </p>
                    </>
                ) : null}
                <Row>
                    <Col
                        className={
                            yearFilterValue && quarterlyStatementListData
                                ? 'statement-download-col overflowYScroll'
                                : 'statement-download-col overflowYHidden'
                        }
                    >
                        {renderContent()}
                    </Col>
                </Row>
            </div>
        </Modal>
    );
};

export default QuarterlyStatementModal;
